import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-916abed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-hotspots" }

import { PropType } from 'vue';
import { Hotspot } from '@/services/stores/hotspots'
import MapHotspot from './MapHotspot.vue';



export default /*#__PURE__*/_defineComponent({
  props: {
  active: {
    type: Number,
    required: false
  },
  hotspots: {
    type: Array as PropType<Hotspot[]>,
    required: true
  }
},
  emits: ["update"],
  setup(__props, { emit }: { emit: ({
  (e: 'update', id: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props




const update = (id: number) => {
  emit('update', id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.hotspots, (h, i) => {
      return (_openBlock(), _createBlock(MapHotspot, {
        key: h.id,
        hotspot: h,
        "is-selected": i === __props.active,
        onChange: update
      }, null, 8, ["hotspot", "is-selected"]))
    }), 128))
  ]))
}
}

})